import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\FekerTech\\Shahen Website New\\node_modules\\@mui\\icons-material\\esm\\Support.js");
;
import(/* webpackMode: "eager", webpackExports: ["SupportView"] */ "D:\\FekerTech\\Shahen Website New\\src\\sections\\support\\view\\support-view.jsx");
